import type { ConnectivityPort } from '@Domain/Ports/Connectivity/ConnectivityPort';
import PortsContext from '@UI/Providers/PortsProvider/PortsContext';
import * as React from 'react';

function useConnectivityPort(): ConnectivityPort {
	const context = React.useContext(PortsContext);

	if (context === null) {
		throw new Error('useConnectivityPort doit être utilisé à l’intérieur d’un PortsProvider.');
	}

	return context.connectivity;
}

export default useConnectivityPort;
